export const hsdeskLoaderVariantValues = [
  'jelly',
  'ring',
  'dots',
  'line',
  'wave'
] as const;

export type HsdeskLoaderVariant = (typeof hsdeskLoaderVariantValues)[number];

export const defaultHsdeskLoaderVariant: HsdeskLoaderVariant = 'jelly';
export const defaultHsdeskLoaderColor = '#2563eb';

export const hsdeskLoaderVariantOptions: Array<{
  value: HsdeskLoaderVariant;
  label: string;
}> = [
  { value: 'jelly', label: 'Trojkat' },
  { value: 'ring', label: 'Ring' },
  { value: 'dots', label: 'Kropki' },
  { value: 'line', label: 'Linie' },
  { value: 'wave', label: 'Fala' }
];

export const hsdeskLoaderColorPresets = [
  '#2563eb',
  '#0f766e',
  '#dc2626',
  '#d97706',
  '#7c3aed',
  '#111827'
];

const hexColorPattern = /^#[0-9a-fA-F]{6}$/;

export function normalizeHsdeskLoaderVariant(
  value?: string | null
): HsdeskLoaderVariant {
  return hsdeskLoaderVariantValues.includes(value as HsdeskLoaderVariant)
    ? (value as HsdeskLoaderVariant)
    : defaultHsdeskLoaderVariant;
}

export function normalizeHsdeskLoaderColor(value?: string | null) {
  const normalizedValue = value?.trim();

  return normalizedValue && hexColorPattern.test(normalizedValue)
    ? normalizedValue
    : defaultHsdeskLoaderColor;
}
